<template lang="pug">
    div.mt-2
        // Selector de tipo de cliente
        b-row
            b-col(cols="12")
                ClientTypeSelector(
                    v-model="form.cliente_tipo"
                    @type-changed="onClientTypeChanged"
                )

        // Formulario para PERSONA
        div(v-if="form.cliente_tipo === 'persona'")
            b-row
                b-col(cols="6")
                    RutAutocompleteOV(
                        v-model="form.rut"
                        :showValidation="$v.rut.$dirty && $v.rut.$error"
                        @client-selected="onClientSelected"
                        @create-new-client="onCreateNewClient"
                        @client-cleared="onClientCleared"
                        @empresa-detected="onEmpresaDetectedEnPersona"
                    )

                b-col(cols="6")
                    b-form-group(label="Nombre" label-for="nombre")
                        b-form-input(
                                v-model="form.nombre"
                                id="nombre"
                                placeholder="Nombre"
                                :state="$v.nombre.$dirty ? !$v.nombre.$error : null"
                                autocomplete="off"
                            )
                        b-form-invalid-feedback(v-if="!$v.nombre.required") El Nombre es obligatorio.

            b-row
                b-col(cols="6")
                    b-form-group(label="Apellido" label-for="apellido")
                        b-form-input(
                            v-model="form.apellido"
                            id="apellido"
                            placeholder="Apellido"
                            :state="$v.apellido.$dirty ? !$v.apellido.$error : null"
                            autocomplete="off"
                            )
                        b-form-invalid-feedback(v-if="!$v.apellido.required") El Apellido es obligatorio.
                b-col(cols="6")
                    b-form-group(label="Correo" label-for="correo")
                        b-form-input(
                            v-model="form.correo"
                            id="correo"
                            type="email"
                            placeholder="Correo"
                            :state="$v.correo.$dirty ? !$v.correo.$error : null"
                            autocomplete="off"
                            )
                        b-form-invalid-feedback(v-if="!$v.correo.required") El Correo es obligatorio.
            b-row
                b-col(cols="6")
                    b-form-group(label="Teléfono" label-for="telefono")
                        b-form-input(
                            v-model="form.telefono"
                            id="telefono"
                            placeholder="Teléfono"
                            :state="$v.telefono.$dirty ? !$v.telefono.$error : null"
                            autocomplete="off"
                            )
                        b-form-invalid-feedback(v-if="!$v.telefono.required") El Teléfono es obligatorio.
                b-col(cols="6")
                    b-form-group(label="Región" label-for="region")
                        b-form-select(
                            v-model="form.region"
                            id="region"
                            :options="regionOptions"
                            :disabled="regionOptions.length === 0"
                            placeholder="Región"
                            :state="$v.region.$dirty ? !$v.region.$error : null"
                            autocomplete="off"
                            )
                        b-form-invalid-feedback(v-if="!$v.region.required") La Región es obligatoria.

            b-row
                b-col(cols="6")
                    b-form-group(label="Comuna" label-for="comuna")
                        b-form-select(
                            v-model="form.comuna"
                            id="comuna"
                            placeholder="Comuna"
                            :options="comunaOptions"
                            :disabled="regionOptions.length === 0"
                            :state="$v.comuna.$dirty ? !$v.comuna.$error : null"
                            autocomplete="off"
                            )
                        b-form-invalid-feedback(v-if="!$v.comuna.required") La Comuna es obligatoria.
                b-col(cols="6")
                    b-form-group(label="Dirección" label-for="calle")
                        b-form-input(
                            v-model="form.calle"
                            id="calle"

                            placeholder="Dirección"
                            :state="$v.calle.$dirty ? !$v.calle.$error : null"
                            autocomplete="off"
                            )
                        b-form-invalid-feedback(v-if="!$v.calle.required") La Dirección es obligatoria.

        // Formulario para EMPRESA
        div(v-else-if="form.cliente_tipo === 'empresa'")
            b-row
                b-col(cols="12")
                    EmpresaAutocomplete(
                        ref="empresaAutocomplete"
                        v-model="form.cliente_id"
                        :showValidation="$v.cliente_id && $v.cliente_id.$dirty && $v.cliente_id.$error"
                        @empresa-selected="onEmpresaSelected"
                        @empresa-cleared="onEmpresaCleared"
                        @create-empresa-requested="onCreateEmpresaRequested"
                    )

            // Campos de solo lectura de la empresa
            b-row(v-if="form.cliente_id")
                b-col(cols="6")
                    b-form-group(label="Razón Social" label-for="razon-social")
                        b-form-input(
                            v-model="empresaData.razon_social"
                            id="razon-social"
                            disabled
                            )
                        small.text-muted Campo de solo lectura

                b-col(cols="6")
                    b-form-group(label="RUT Empresa" label-for="rut-empresa")
                        b-form-input(
                            v-model="empresaData.rut"
                            id="rut-empresa"
                            disabled
                            )
                        small.text-muted Campo de solo lectura

            // Campos editables (se guardan en la OV)
            b-alert.mt-3(show variant="info" v-if="form.cliente_id")
                font-awesome-icon(:icon="['fas', 'info-circle']")
                |  Los siguientes campos se prellenan desde la empresa, pero puedes modificarlos para esta OV específica. Los cambios no afectarán los datos de la empresa.

            b-row(v-if="form.cliente_id")
                b-col(cols="6")
                    b-form-group(label="Correo Electrónico" label-for="correo-empresa")
                        b-form-input(
                            v-model="form.correo"
                            id="correo-empresa"
                            type="email"
                            placeholder="Correo"
                            :state="$v.correo.$dirty ? !$v.correo.$error : null"
                            )
                        b-form-invalid-feedback(v-if="!$v.correo.required") El Correo es obligatorio.
                        
                        // Mostrar correos disponibles de la empresa
                        div.mt-2(v-if="emailsDisponibles.length > 0")
                            small.text-muted Correos registrados en la empresa:
                            .email-chips.mt-1
                                b-button(
                                    v-for="(email, index) in emailsDisponibles"
                                    :key="index"
                                    size="sm"
                                    :variant="form.correo === email ? 'primary' : 'outline-secondary'"
                                    @click="form.correo = email"
                                    class="mr-1 mb-1"
                                ) {{ email }}

                b-col(cols="6")
                    b-form-group(label="Región" label-for="region-empresa")
                        b-form-select(
                            v-model="form.region"
                            id="region-empresa"
                            :options="regionOptions"
                            :state="$v.region.$dirty ? !$v.region.$error : null"
                            )
                        b-form-invalid-feedback(v-if="!$v.region.required") La Región es obligatoria.

            b-row(v-if="form.cliente_id")
                b-col(cols="6")
                    b-form-group(label="Comuna" label-for="comuna-empresa")
                        b-form-select(
                            v-model="form.comuna"
                            id="comuna-empresa"
                            :options="comunaOptions"
                            :state="$v.comuna.$dirty ? !$v.comuna.$error : null"
                            )
                        b-form-invalid-feedback(v-if="!$v.comuna.required") La Comuna es obligatoria.

                b-col(cols="6")
                    b-form-group(label="Dirección" label-for="direccion-empresa")
                        b-form-input(
                            v-model="form.calle"
                            id="direccion-empresa"
                            placeholder="Dirección"
                            :state="$v.calle.$dirty ? !$v.calle.$error : null"
                            )
                        b-form-invalid-feedback(v-if="!$v.calle.required") La Dirección es obligatoria.
</template>

<script>
import { mapActions } from 'vuex'
import { validationMixin } from 'vuelidate'
import RutAutocompleteOV from './RutAutocompleteOV.vue'
import ClientTypeSelector from './ClientTypeSelector.vue'
import EmpresaAutocomplete from './EmpresaAutocomplete.vue'

export default {
  name: 'StepCliente',
  components: {
    RutAutocompleteOV,
    ClientTypeSelector,
    EmpresaAutocomplete,
  },
  props: {
    form: {
      type: Object,
      required: true,
    },
    $v: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      regiones: [],
      regionOptions: [],
      empresaData: {
        razon_social: '',
        rut: '',
      },
      emailsDisponibles: [],
    }
  },
  mixins: [validationMixin],
  computed: {
    comunaOptions() {
      if (this.form.region) {
        const region = this.regiones.find((c) => c.region === this.form.region)
        if (region && region.comunas) {
          return region.comunas
            .map((c) => ({
              value: c,
              text: c,
            }))
            .sort((a, b) => a.value.localeCompare(b.value))
        }
      }
      return [{ value: null, text: 'Selecciona una región' }]
    },
  },
  methods: {
    ...mapActions('ClientStore', ['listRegiones']),
    ...mapActions('OVStore', ['getEmpresaDatosPrellenado']),

    // Cambio de tipo de cliente
    onClientTypeChanged(newType) {
      // Limpiar todos los campos
      this.clearAllFields()

      this.$bvToast.toast(
        `Seleccionaste ${
          newType === 'persona' ? 'Persona' : 'Empresa'
        }. Completa los datos correspondientes.`,
        {
          variant: 'info',
          autoHideDelay: 3000,
        }
      )
    },

    // Manejo de eventos del autocompletado de PERSONA
    onClientSelected(clientData) {
      // Autocompletar todos los campos del formulario
      Object.assign(this.form, clientData)

      // Mostrar notificación de éxito
      this.$bvToast.toast('Cliente encontrado y datos completados', {
        variant: 'success',
        autoHideDelay: 3000,
      })
    },

    onCreateNewClient(rut) {
      // Solo llenar el RUT, mantener los demás campos vacíos para que el usuario los complete
      this.form.rut = rut
      this.form.nombre = ''
      this.form.apellido = ''
      this.form.correo = ''
      this.form.telefono = ''
      this.form.region = ''
      this.form.comuna = ''
      this.form.calle = ''

      this.$bvToast.toast('Complete los datos del nuevo cliente', {
        variant: 'info',
        autoHideDelay: 3000,
      })
    },

    onClientCleared() {
      this.clearPersonaFields()
    },

    // Manejo de eventos del autocompletado de EMPRESA
    async onEmpresaSelected(empresa) {
      await this.prellenarDatosEmpresa(empresa)
    },

    // El RutAutocompleteOV (pestaña Persona) detectó que el RUT ingresado
    // corresponde a una empresa: cambiamos de pestaña y delegamos la
    // selección en el propio EmpresaAutocomplete (misma que usa el hit
    // del dropdown) para que su estado interno —texto de búsqueda y
    // tarjeta "seleccionada"— quede idéntico al de la selección manual.
    async onEmpresaDetectedEnPersona(empresa) {
      this.form.cliente_tipo = 'empresa'

      this.$bvToast.toast(
        `El RUT ${empresa.rut} corresponde a la empresa "${empresa.razon_social}". Cambiamos a la pestaña Empresa.`,
        {
          variant: 'info',
          autoHideDelay: 4000,
        }
      )

      // El bloque Empresa recién se monta al cambiar cliente_tipo
      // (v-else-if), así que esperamos el próximo tick antes de
      // acceder al ref.
      await this.$nextTick()
      if (this.$refs.empresaAutocomplete) {
        this.$refs.empresaAutocomplete.onEmpresaSelected(empresa)
      }
    },

    // Lógica de prellenado compartida entre la selección directa en la
    // pestaña Empresa y la detección automática desde la pestaña Persona.
    async prellenarDatosEmpresa(empresa) {
      try {
        // Obtener datos completos de la empresa para prellenar
        const data = await this.getEmpresaDatosPrellenado(empresa.id)

        // Guardar datos de solo lectura
        this.empresaData = {
          razon_social: data.razon_social,
          rut: data.rut,
        }

        // Prellenar campos editables
        this.form.correo = data.email || ''
        this.form.calle = data.direccion || ''
        this.form.region = data.region || ''

        // Para comuna, si es un ID necesitamos convertirlo al nombre
        if (data.comuna_nombre) {
          this.form.comuna = data.comuna_nombre
        } else if (data.comuna) {
          this.form.comuna = data.comuna
        }

        // Guardar lista de correos disponibles
        this.emailsDisponibles = data.emails_disponibles || []

        this.$bvToast.toast(
          'Datos de la empresa cargados. Puedes modificar los campos editables.',
          {
            variant: 'success',
            autoHideDelay: 4000,
          }
        )
      } catch (error) {
        console.error('Error al cargar datos de empresa:', error)
        this.$bvToast.toast('Error al cargar datos de la empresa', {
          variant: 'danger',
          autoHideDelay: 3000,
        })
      }
    },

    onEmpresaCleared() {
      this.clearEmpresaFields()
    },

    onCreateEmpresaRequested() {
      this.$bvToast.toast(
        'Redirigiendo al módulo de Clientes para crear la empresa...',
        {
          variant: 'info',
          autoHideDelay: 3000,
        }
      )

      // Aquí puedes navegar al módulo de clientes o abrir un modal
      // this.$router.push({ name: 'crear-empresa' })
    },

    // Métodos auxiliares de limpieza
    clearAllFields() {
      this.clearPersonaFields()
      this.clearEmpresaFields()
    },

    clearPersonaFields() {
      this.form.rut = ''
      this.form.nombre = ''
      this.form.apellido = ''
      this.form.correo = ''
      this.form.telefono = ''
      this.form.region = ''
      this.form.comuna = ''
      this.form.calle = ''
    },

    clearEmpresaFields() {
      this.form.cliente_id = null
      this.form.correo = ''
      this.form.region = ''
      this.form.comuna = ''
      this.form.calle = ''
      this.empresaData = {
        razon_social: '',
        rut: '',
      }
      this.emailsDisponibles = []
    },
  },
  async created() {
    try {
      const regiones = await this.listRegiones()
      this.regiones = regiones
      this.regionOptions = regiones.map((r) => ({
        value: r.region,
        text: r.region,
      }))

      // Inicializar cliente_tipo si no existe
      if (!this.form.cliente_tipo) {
        this.form.cliente_tipo = 'persona'
      }
    } catch (error) {
      console.error('Error al cargar las regiones:', error)
    } finally {
      this.loading = false
    }
  },
}
</script>

<style lang="scss" scoped>
.email-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
}

::v-deep .alert-info {
  font-size: 0.9rem;
  padding: 0.75rem 1rem;
}
</style>
